(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define("ChartTypeSelector", ["d3"], factory);
	else if(typeof exports === 'object')
		exports["ChartTypeSelector"] = factory(require("d3"));
	else
		root["ChartTypeSelector"] = factory(root["d3"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 